<!-- <p>visitor-details works!</p> -->
<mat-divider></mat-divider>
<div class="visitor-detail-wrapper">
  <mat-card class="visitor-detail-card">
    <mat-card-header class="visitor-detail-card-header">
      {{ "Visitors Details" | uppercase }}
    </mat-card-header>
    <mat-card-content class="visitor-detail-card-content">
      <form [formGroup]="showVisitorDetailsForm">
        <mat-grid-list cols="2" rowHeight="100px" [gutterSize]="'18px'">
          <mat-grid-tile
            [rowspan]="screenInfo == ScreenType.Mobile ? 10 : 5"
            [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
          >
            <div class="internalMatGrid">
              <mat-grid-list
                [cols]="screenInfo == ScreenType.Mobile ? 1 : 2"
                rowHeight="90px"
              >
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visitor Id</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="visitorID"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>First Name</mat-label>
                    <input
                      readonly
                      formControlName="firstName"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Last Name</mat-label>
                    <input
                      readonly
                      formControlName="lastName"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <input readonly formControlName="email" matInput />
                    <mat-label>Visitor Email</mat-label>
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visitor Contact</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="phoneNumber"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Host Name</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="hostName"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visit Purpose</mat-label>
                    <input
                      readonly
                      formControlName="purpose"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Visit Date</mat-label>
                    <input
                      readonly
                      formControlName="visitDateTime"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Check In</mat-label>
                    <input
                      readonly
                      formControlName="checkIn"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Check Out</mat-label>
                    <input
                      readonly
                      formControlName="checkOut"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button disabled mat-raised-button>Update</button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile>
                  <div class="button-tile">
                    <button (click)="onClose()" mat-raised-button>Close</button>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            rowspan="5"
            [colspan]="screenInfo == ScreenType.Mobile ? 2 : 1"
          >
            <div class="internalMatGridAssetTable">
              <div class="visitor-image" tabindex="0">
                <img
                  [src]="showVisitorDetailsForm.controls.identityID.value"
                  alt="Identity Id"
                />
              </div>
              <div class="visitor-image" tabindex="0">
                <img
                  [src]="showVisitorDetailsForm.controls.profilePicture.value"
                  alt="Profile Picture"
                />
              </div>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </mat-card-content>
    <mat-card-actions></mat-card-actions>
  </mat-card>
  <br />
</div>
